import { Box, Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ObjectsEnum } from "..";
import SolidGradientColorPicker from "../../../../../../../components/common/SolidGradientColorPicker/SolidGradientColorPicker";
import { useAppStore } from "../../../../../../../hooks/useStores";
import useDesignEditorUtils, { FeatureType, Property } from "../../../../../../CustomUtils/UseDesignEditor";
import MainTabHeader from "../../../../../../components/common/MainTabHeader/MainTabHeader";
import UseBrandConfigs from "../../../../../../hooks/useBrandConfigs";
import { useEditor } from "../../../../../../hooks/useEditor";
import { LayerType } from "../../../../../../types";
import SelectedBrandColors from "../Common/SelectedBrandColors/SelectedBrandColors";
import styles from "./CanvasColor.module.scss";
export type Iprops = {};

const CanvasColor = ({}: Iprops) => {
	const { t } = useTranslation("translation");
	const editor = useEditor();
	const { campaignStore } = useAppStore();
	const { EditAllAds, getRgbAndOpacityFromRgba, updateColorOpacity } = useDesignEditorUtils();
	const { modifyActiveObjectProperty } = UseBrandConfigs();
	const [color, setColor] = useState(
		editor && editor?.frame?.background?.fill && typeof editor.frame.background.fill == "string"
			? updateColorOpacity(editor.frame.background.fill, editor.frame.background.opacity)
			: "#fff",
	);
	const [initialFrame, setInitialFrame] = useState(undefined);
	useEffect(() => {
		let watcher = async () => {
			const initialFrame = editor?.objects.findOneById(ObjectsEnum.InitialFrame);
			setInitialFrame(initialFrame);
			setColor(
				editor && editor?.frame?.background?.fill && typeof editor.frame.background.fill == "string"
					? updateColorOpacity(editor.frame.background.fill, editor.frame.background.opacity)
					: "#fff",
			);
		};
		if (editor) {
			editor.on("canvas:updated", watcher);
		}
		return () => {
			if (editor) {
				editor.off("canvas:updated", watcher);
			}
		};
	}, [editor]);

	useEffect(() => {
		const initialFrame = editor?.objects.findOneById(ObjectsEnum.InitialFrame);
		setInitialFrame(initialFrame);
	}, []);

	const updateBackgroundColor = (color: string, brandColor: boolean = false) => {
		const result = getRgbAndOpacityFromRgba(color);
		setColor(color);
		campaignStore.canvasColorPicker = color;
		if (editor) {
			editor.frame.setBackgroundColor(result?.rgb ?? color);
			if (!brandColor) {
				editor.frame.background.set({ opacity: result?.opacity ?? 1 });
				editor.objects.update({ opacity: result?.opacity ?? 1, brandId: undefined }, undefined, false);
			}
			let newColor = null;
			if (brandColor) {
				newColor = updateColorOpacity(color, editor.frame.background.opacity);
			}
			if (!campaignStore.isEditingAllAds) editor.history.save();
			EditAllAds(LayerType.BACKGROUND, "", FeatureType.COLOR, newColor ?? color);
		}
	};

	return (
		<>
			<Box className={styles.container}>
				<MainTabHeader title={t(`editor.panels.panelsList.fillColor`)} />
				<Box className={`${styles.tabs} ${styles.fullHeight}`}>
					<Box className={styles.ColorFillContent}>
						<Box className={styles.colorPickerContainer}>
							<SolidGradientColorPicker
								color={color}
								onChange={(color: string) => {
									updateBackgroundColor(color);
									modifyActiveObjectProperty(initialFrame, Property.COLOR_NUMBER, undefined);
								}}
								hideColorTypeBtns={true}
							/>
						</Box>
						<Divider className={styles.mainDivider} />
						<SelectedBrandColors
							activeObject={initialFrame}
							updateColor={(color: string) => {
								updateBackgroundColor(color, true);
							}}
							property={Property.COLOR_NUMBER}
						/>
					</Box>
				</Box>
			</Box>
		</>
	);
};

export default CanvasColor;
